export enum NavigationStepLabels {
  EXTRAS = 'extras',
  DEALER = 'dealer',
  DETAILS = 'details',
  CONFIRMATION = 'confirmation',
  PAYMENT = 'payment',
}
